export enum NavigationDirection {
  PREVIEW = 'preview',
  NEXT = 'next',
}
